import * as React from "react";
import { useGetCartExpressPaymentMethods } from "./use-get-cart-express-payment-methods.js";
const useIsExpressPaymentMethodSupported = (paymentMethod) => {
  const [getExpressPaymentMethods, { loading, called, data, error }] = useGetCartExpressPaymentMethods();
  const fetchPaymentMethods = React.useCallback(
    (cartId) => {
      if (cartId) {
        getExpressPaymentMethods(cartId);
      }
    },
    [getExpressPaymentMethods]
  );
  const expressPaymentMethod = data?.find(({ name }) => name === paymentMethod);
  return [
    fetchPaymentMethods,
    {
      isPaymentMethodSupported: Boolean(expressPaymentMethod),
      paymentConfiguration: expressPaymentMethod?.configuration,
      loading,
      called,
      error
    }
  ];
};
export {
  useIsExpressPaymentMethodSupported
};
//# sourceMappingURL=use-is-express-payment-method-supported.js.map
